module.exports = __webpack_public_path__ + "static/media/27.7aa4f05c.jpg";